import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
//^^^ Support for IE-11
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
//import App from './App';
import SIVHCompute from './App';
import * as serviceWorker from './serviceWorker';

//ReactDOM.render(<App />, document.getElementById('root'));
ReactDOM.render(<SIVHCompute/>, document.getElementById("root"));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
